

var guidUtil = require('../../guid/guidUtil.js');
var stringUtil = require('../../string/stringUtil.js');
var cliNotificationMessageHandler = require('./cliNotificationMessageHandler.js');
var terminalUtility = require('../../domain/terminalUtility.js');
const logger = require('../../logger/logger.js');
var stateManager = require('../../state/stateManager.js');
var cashFloatAction = require('../../state/actions/cashFloat/cashFloatAction.js');
var snoozeAction = require('../../state/actions/snooze/snoozeAction.js');
var viewUtil = require('../../view/viewUtil.js');
var userNotificationsUtil = require('../../userNotifications/userNotificationsUtil.js');
var sounds = require('../../sounds/sounds.js');

module.exports.onMessage = function (payload)
{
    var tracingContext = createTracingContext(payload);

    try
    {
        logger.info(`Notification Message received with notification type as '${payload.notificationType}'.`, tracingContext);
        if (stringUtil.isStringNullOrEmpty(payload.notificationType))
        {
            logger.warn(`Notification Message without notification type`, tracingContext);
            return;
        }

        if (stringUtil.areStringSame(payload.notificationType, "float.session"))
        {
            handleFloatSessionMessage(payload, tracingContext);
            return;
        }

        if (stringUtil.areStringSame(payload.notificationType, "snooze"))
        {
            handleSnoozeMessage(payload, tracingContext);
            return;
        }

        if (stringUtil.areStringSame(payload.notificationType, "cli"))
        {
            cliNotificationMessageHandler.handleCliMessage(payload, tracingContext);
            return;
        }

        if (stringUtil.areStringSame(payload.notificationType, "user.action.notification"))
        {
            handleUserNotifications(payload, tracingContext);
            return;
        }

        logger.warn(`Notification Message with unknown notification type ${payload.notificationType}`, tracingContext);
    }
    catch (error)
    {
        logger.error(`Following error occurred on handling notification message. ${error}`, tracingContext, error);
    }
}

function createTracingContext(payload)
{
    var tracingContext = {};
    if (payload.tracingContext != null)
    {
        tracingContext = payload.tracingContext;
        delete payload.tracingContext;
        return tracingContext;
    }

    tracingContext.traceId = guidUtil.generateGuid();
    Object.assign(tracingContext, payload);
    return tracingContext;
}

function handleFloatSessionMessage(floatSessionPayload, tracingContext)
{
    var session = floatSessionPayload.session;
    if (session != null && session.journals == null)
        session.journals = [];
    
    if (!stringUtil.areStringSame(session.floatIdentifier, terminalUtility.getTerminalFloatIdentifier()))
        return;
    
    stateManager.getStore().dispatch(cashFloatAction.createAction(session));
}

function handleSnoozeMessage(snoozePayload, tracingContext)
{
    stateManager.getStore().dispatch(snoozeAction.createAction(snoozePayload.snoozes));
}

function handleUserNotifications(payload, tracingContext)
{
    if(payload.action === 'delete')
    {
        logger.info(`Delete action found for user notifications.`, tracingContext);
        const notificationId = payload.actionPayload.id;
        viewUtil.clearAlertForId(notificationId);
        userNotificationsUtil.deleteNotifications(payload.actionPayload.id);
        return;
    }

    if(payload.action !== 'add')
    {
        logger.error(`User notification payload found with invalid action: ${payload.action}`, tracingContext);
        return;
    }

    var userNotification = payload.actionPayload;
    if (userNotification == null)
    {
        logger.error(`Null user notification payload found`, tracingContext);
        return;
    }

    if (userNotification.type == "manual.accept.order")
    {
        let orderPayload = userNotification.payload;
        if (orderPayload == null)
        {
            logger.error(`Null order payload within user notification payload found`, tracingContext);
            return;
        }
    
        logger.info(`Adding a manual accept order notification for order number: ${orderPayload.number} and channel: ${orderPayload.channel}`);
    }
    

    userNotificationsUtil.addUpdateNotifications(userNotification);
    viewUtil.showAlert("user.notification", userNotification, userNotification.id);
    sounds.playNewOrderSound();
}
